import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { X, ZoomIn } from 'lucide-react';
import type { VisitFileDto } from '../../types/api.types';
import { AuthenticatedImage } from '../common/AuthenticatedImage';
import { Modal } from '../common/Modal';

interface ImageGalleryProps {
  images: VisitFileDto[];
  onDelete?: (id: number) => void;
  groupedByDate?: boolean;
}

export const ImageGallery: React.FC<ImageGalleryProps> = ({
  images,
  onDelete,
}) => {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState<VisitFileDto | null>(null);

  if (images.length === 0) {
    return <p className="text-muted">{t('visits.noImagesFound')}</p>;
  }

  return (
    <>
      <div className="row g-3">
        {images.map((image) => (
          <div key={image.id} className="col-6 col-md-4 col-lg-3 position-relative">
            <div className="position-relative">
              <AuthenticatedImage
                src={image.fileUrl}
                alt={`Visit image ${image.id}`}
                className="w-100 rounded shadow-sm"
                style={{ 
                  height: '200px', 
                  objectFit: 'cover',
                  cursor: 'pointer'
                }}
                onClick={() => setSelectedImage(image)}
              />
              <div 
                className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-0 bg-opacity-50-hover d-flex align-items-center justify-content-center opacity-0 opacity-100-hover transition-opacity rounded"
                style={{ cursor: 'pointer' }}
                onClick={() => setSelectedImage(image)}
              >
                <ZoomIn className="text-white" size={32} />
              </div>
              {onDelete && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(image.id);
                  }}
                  className="position-absolute top-0 end-0 m-2 btn btn-danger btn-sm rounded-circle p-1 opacity-0 opacity-100-hover transition-opacity"
                  style={{ width: '32px', height: '32px' }}
                >
                  <X size={16} />
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      <Modal
        isOpen={selectedImage !== null}
        onClose={() => setSelectedImage(null)}
        size="xl"
      >
        {selectedImage && (
          <AuthenticatedImage
            src={selectedImage.fileUrl}
            alt="Full size"
            className="w-100 h-auto rounded"
          />
        )}
      </Modal>
    </>
  );
};
